<script setup lang="ts">
  import ElList from '@/components/common/ElList/ElList.vue';

  defineOptions({ name: 'ElNavigation' });

  defineProps<{
    horizontal?: boolean;
  }>();
</script>

<template>
  <ElList
    :horizontal="horizontal"
    :class="['el-menu', { 'justify-evenly max-wrap': horizontal }]"
  >
    <slot />
  </ElList>
</template>
